var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantingDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5293 37.2949C20.4973 37.685 20.4973 38.1351 20.9452 38.3152C21.3931 38.4952 21.2011 38.0751 21.1372 37.8651C21.0732 37.655 20.7533 37.475 20.5293 37.2949Z",
    fill: "#491086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5293 37.2949C20.4672 37.1589 20.3923 37.0284 20.3054 36.9049C18.9617 34.6244 18.3539 32.4339 18.9297 29.6434C19.8255 25.3224 16.8822 22.2918 11.4756 20.9715C8.82024 20.3114 6.10093 20.2514 3.3816 20.1914C2.74175 20.1914 2.00594 20.1914 2.00594 21.0616C2.00594 21.3963 2.00447 21.7311 2.00299 22.0658C1.98908 25.211 1.9752 28.3492 3.18963 31.4138C5.3011 36.6048 10.9637 37.8051 15.5706 35.5846C16.6583 35.0445 17.0102 35.3145 17.4261 36.1847C19.2496 39.6955 19.9215 43.4763 20.1134 47.3471C20.1234 47.4637 20.1263 47.5853 20.1293 47.7074C20.1456 48.371 20.1623 49.0481 21.2971 48.9974C22.4736 48.9449 22.4483 48.2483 22.4238 47.5722C22.4203 47.4761 22.4168 47.3804 22.4168 47.287C22.3971 43.0306 23.0438 38.7946 24.3364 34.7144C24.9122 32.884 25.1362 32.734 26.9917 33.1841C32.5584 34.4443 36.7813 31.9238 38.157 26.7027C38.8913 23.9983 39.2144 21.2102 39.1168 18.421C39.1168 17.6108 38.8288 17.2207 37.9331 17.2207C34.318 17.1607 30.7349 17.2507 27.2477 18.481C21.3292 20.5814 20.7533 26.0426 22.6728 29.9734C23.1527 30.9336 23.2487 31.6538 22.7688 32.584C21.905 34.2643 21.5211 36.0647 21.1372 37.8651C20.7448 38.0123 20.7134 37.8097 20.6813 37.6033C20.6611 37.4731 20.6407 37.3414 20.5293 37.2949ZM24.5603 29.1032C26.2559 26.9128 27.9515 25.2324 30.095 23.9721C30.1738 23.9228 30.2522 23.871 30.3304 23.8194C30.9179 23.4314 31.4893 23.0541 32.1105 23.8221C32.8143 24.6923 32.0465 25.3224 31.3746 25.7425C29.6862 26.787 28.2123 28.1084 27.0237 29.6433C26.4159 30.3935 26.4479 30.7536 27.5356 31.0536C31.4066 32.1339 34.5418 30.5135 35.7895 26.5527C36.4614 24.4822 36.6534 22.3518 36.8133 20.1913C36.8773 19.5012 36.6534 19.1711 35.8536 19.2311L35.5521 19.2549C32.9975 19.4559 30.4485 19.6564 28.0475 20.5514C24.9443 21.6917 23.6966 23.6721 24.1445 26.7627C24.2048 27.1586 24.2777 27.5546 24.3712 28.0621C24.4265 28.3624 24.489 28.7017 24.5603 29.1032ZM10.1959 22.9219C15.4746 23.9121 17.3941 26.3426 16.4023 30.8736C16.0746 30.6072 15.7692 30.3478 15.4735 30.0965C14.9033 29.6121 14.3689 29.1581 13.779 28.7432C12.8721 28.1378 11.9325 27.5769 10.9637 27.0628C10.1319 26.5827 9.23613 26.2226 8.62828 27.2429C8.09597 28.1363 8.86399 28.5004 9.53578 28.819C9.63112 28.8642 9.72451 28.9085 9.81198 28.9532C11.6036 29.8362 13.2342 30.9807 14.6428 32.3439C15.0587 32.794 15.4106 33.1841 14.6428 33.6642C11.7315 35.4346 7.06064 34.2043 5.621 31.2037C4.40531 28.6532 4.18137 25.9226 3.98942 23.162C3.92608 22.3896 4.36445 22.4113 4.96304 22.441L4.98117 22.4419C6.72964 22.4813 8.4726 22.6418 10.1959 22.9219Z",
    fill: "#491086"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13968_30109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 18.3327C12.0877 18.3327 8.91634 15.1614 8.91634 11.2493C8.91634 7.33733 12.0877 4.16602 15.9997 4.16602C19.9117 4.16602 23.083 7.33733 23.083 11.2493C23.083 15.1614 19.9117 18.3327 15.9997 18.3327Z",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.66602H13.5",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.91602V11.2493",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 11.25H16",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.66602V3.33268",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 38.5L37.5 41.5M37.5 41.5L40.5 44.5M37.5 41.5H45.8125C46.7445 41.5 47.5 40.8285 47.5 40V26.5",
    stroke: "#491086",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13968_30109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 26 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantingDate);
export default __webpack_public_path__ + "static/media/plantingDate.3e0512c57052453b2868a8d738d292dd.svg";
export { ForwardRef as ReactComponent };